const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });

export const money = (cents) => (cents == null ? "—" : usd.format(cents / 100));

export const pct = (v) => (v == null ? "—" : `${Number(v).toFixed(2)}%`);

export function fmtDate(iso) {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/New_York",
  });
}

export const typeLabel = (t) => (t === "simple" ? "Simple interest · Actual/365" : "Amortized · Monthly");

export const feeRule = (loan) =>
  loan.late_fee_type === "percent"
    ? `${pct(loan.late_fee_value)} of installment`
    : `${money(loan.late_fee_value)} flat`;

export function levelPayment(principalCents, apr, n) {
  const r = apr / 100 / 12;
  if (!n || n < 1) return 0;
  if (!r) return Math.round(principalCents / n);
  return Math.round((principalCents * r) / (1 - Math.pow(1 + r, -n)));
}

export function todayET() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York" }).format(new Date());
}

export function addMonths(iso, n) {
  const [y, m, d] = iso.split("-").map(Number);
  const target = new Date(y, m - 1 + n, 1);
  const last = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(d, last));
  const mm = String(target.getMonth() + 1).padStart(2, "0");
  const dd = String(target.getDate()).padStart(2, "0");
  return `${target.getFullYear()}-${mm}-${dd}`;
}
